import { useState, useEffect, useRef, useMemo } from "react";
import moment from 'moment';
import { ASSET_TYPE_OPTIONS, fieldDateFormat } from '../../../constants';
import { enqueueSnackbar } from "notistack";
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import { Table, TableBody, TableSortLabel, Paper, Grid, TableRow, TableHead, TableCell, MenuItem, Button, Box, Checkbox, Tabs, Tab } from "@mui/material";
import { getDeleteInvoicePayload, getDeleteInvoicePopUpProps } from '..';
import { Pagination, PageLoader, DeletePopUp, STableLoader, PopOverCTA, FilterComponent, jetStreamInstance, titanAviationIntance, hanwahaInstance, gaTelesisInstance } from "../../../shared_elements";
import { checkApiStatus, getGlobalCookie } from "../../../utils";
import { ChangeInvoiceStatus, InvoiceList, GenerateManagementFeeModal, BulkChangeInvoiceStatus, BulkSendMailModal, RevertInvoiceStatus, BulkDeleteInvoiceModal } from "../components";
import NoRecordFound from "../../../shared_elements/NoRecordFound";
import { globalDeleteService, globalGetService } from "../../../utils/globalApiServices";
import { deleteInvoiceApi, getInvoiceAuthUrl, getInvoicesApi, getAssetListApi, getInvoiceApprovalReportApi } from "../apiService";
import { getAircraftTypeList, getEngineTypeList } from "../../asset_listing/apiServices";
import { getQbStatusApi } from "../../quickBooks/apiService";
import { setGlobalCookie } from "../../../utils";
import { addInvoiceObj, invoiceTypes, getManagementFeeSelectDisabledReason } from "..";
import AddFleetInvoice from "../components/AddFleetInvoice";
import SummaryInvoices from "./SummaryInvoices";
import { ButtonLoader } from "../../../shared_elements/components";
import FileUploadLayout from "../../../shared_elements/components/FileUploadLayout";
import { useDispatch, useSelector } from "react-redux";
import fileUpload, { getApiResponse } from "../../../utils/fileUpload";
import { trackActivity } from "../../../utils/mixpanel";
import { RoleBaseAccess } from "../../../hoc";
import { PermissionWrapper } from "../../../wrappers";
import { ArrowDownward as ArrowDownwardIcon } from "@mui/icons-material";
import Paginationstat from "../../statistics/components/Paginationstat";
import { getStorage, getCurrencyAc, getOwnerListApi, getLesseeAc } from "../../../shared_elements/actionCreators";
import FleetInvHeaderCard from "../components/fleetInvHeaderCard";
import ExportFileTypeComp from "../../../shared_elements/components/ExportFileTypeComp";
import RevisionHistory from "../../../shared_elements/components/RevisionHistory";
import ModuleWiseRevisionHistory from "../../../shared_elements/components/ModuleWiseRevisionHistory";
import UploadAttachmentsModal from "../components/InvUploadAttachmentsModal";
import DeploymentBanner from "../../../shared_elements/components/DeploymentBanner";
import DeploymentBannerWithOffset from "../../../shared_elements/components/DeploymentBannerWithOffSet";

const invoiceStatusOptions = [
	{ label: 'Draft', value: 1 },
	{ label: 'Sent', value: 2 },
	{ label: 'Paid', value: 3 },
	{ label: 'Cancelled', value: 4 },
	{ label: 'Partially-Paid', value: 5 },
	...(jetStreamInstance ? [{ label: 'Updated', value: 6 }] : []),
	...(titanAviationIntance ? [{ label: 'Approved', value: 7 }] : []),
];
const mrPendingApprovalStageOptions = 
	[{ label: 'Finance Control', value: 1 }, 
	{ label: 'Accounting Control', value: 2 },
	{ label: 'Final Control', value: 3 }]
;

const invoiceTypeOptions = [
	{ label: 'Reserve', value: 1 },
	{ label: 'Rental', value: 2 },
	{ label: 'Penalty', value: 3 },
	{ label: 'Debit', value: 4 },
	{ label: 'Credit', value: 5 },
	{ label: 'Adhoc', value: 9 },
	{ label: 'Security Deposit', value: 6 },
	{ label: 'Management Fee', value: 10 },
];

const invoiceSubTypeOptions = [
	{ label: 'Advanced', value: '1' },
	{ label: 'Arrears', value: '2' },
];


const InvoicesHd = ({ bulkFlag, sortInfo, onChangeBulkOps, createSortHandler, selectedCount, selectableCount, onSelectAll, hasAnySelection }) => {
	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: `Fleet Invoices`, page_type: page_type, })
	}
	const tableSorting = (key, name) => {
		return (
			<TableSortLabel
				active={sortInfo.sort_by === key ? true : false}
				direction={sortInfo.sort_by === key ? sortInfo.sort : 'asc'}
				onClick={() => { createSortHandler(key); handleItemClicked(`Table Sorting: ${name}`) }}
			>
				{name}
			</TableSortLabel>
		)
	}
	return (
		<TableHead>
			<TableRow>
				<TableCell className="table-actions-header" sx={{ width: 140, whiteSpace: "nowrap"}}>
					<Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
						<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
							<Checkbox
								size="small"
								// indeterminate={selectedCount > 0 && selectedCount < selectableCount}
								checked={selectableCount > 0 && selectedCount === selectableCount}
								disabled={!hasAnySelection || selectableCount === 0}
								onChange={onSelectAll}
							/>
						</PermissionWrapper>
						Action(s)
					</Box>
				</TableCell>
				<TableCell sx={{ minWidth: '110px' }}> {tableSorting('asset', 'Asset')}</TableCell>
				<TableCell sx={{ minWidth: '140px' }}> {tableSorting('invoice_number', 'Invoice Number')}</TableCell>
				<TableCell sx={{ minWidth: "110px" }}>{tableSorting('lessor', 'Lessor/Holdco')}</TableCell>
				<TableCell sx={{ minWidth: "110px" }}>{tableSorting('lessee', 'Lessee')}</TableCell>
				<TableCell sx={{ minWidth: '110px' }}> {tableSorting('date', 'Invoice Date')}</TableCell>
				<TableCell sx={{ minWidth: '110px' }}> {tableSorting('due_date', 'Due Date')}</TableCell>
				<TableCell sx={{ minWidth: '110px' }}> {tableSorting('period', 'Invoice Period')}</TableCell>
				<TableCell sx={{ minWidth: '120px' }}> {tableSorting('status', 'Status')}</TableCell>
				<TableCell sx={{ minWidth: '120px' }}> {tableSorting('amount', 'Amount')}</TableCell>
			</TableRow>
		</TableHead>
	);
};


const FleetInvoices = () => {
	const { fileUploadDetails, currencies, owner, lessee, permission } = useSelector((state) => state.leases);
	const navigate = useNavigate()
	const location = useLocation();
	const dispatch=useDispatch();
	const params = useParams();
	const headerCardRef = useRef(null);
	const [isLoading, setLoading] = useState(false);
	const [skeletonLoader, setSkeletonLoader] = useState(false);
	const [invoicesInfo, setInvoicesInfo] = useState({ list: [], pagination: {} });
	const [addEditInvoice, setAddEditInvoice] = useState({ mode: '', modal: false, data: null, type: '' })
	const [deleteInvoices, setDeleteInvoices] = useState({ modal: false, item: {}, data: { ids: [] } })
	const [sortInfo, setSortInfo] = useState({ sort: 'desc', sort_by: gaTelesisInstance ? 'period' : 'date' });
	const [filter, setFilter] = useState({});
    const [isExport,seIsExport]=useState(false)
    const [isBulkExport,setIsBulkExport]=useState(false)
	const [uploadFileProgressData, setUploadFileProgressData]=useState({})
	const [uploadFileStatus, setUploadFileStatus] = useState({ mode: '', modal: false, data: null });
	const [uploadAttachments, setUploadAttachments] = useState({ modal: false, data: null });
	const [slug, setSlug] = useState({})
	const [assetList, setAssetList] = useState([]);
	const [assetListLoading, setAssetListLoading] = useState(false);
	const [aircraftTypes, setAircraftTypes] = useState([]);
	const [engineTypes, setEngineTypes] = useState([]);
	const [drawerAssetType, setDrawerAssetType] = useState(undefined);
	const [drawerAircraftType, setDrawerAircraftType] = useState(undefined);
	const [drawerEngineType, setDrawerEngineType] = useState(undefined);
	const [changeInvStatus,setChangeInvStatus]=useState({ modal: false, data: null });
	const [revisionHistory, setRevisionHistory] = useState({ mode: '', modal: false, data: null });
	const [selectedInvoices, setSelectedInvoices] = useState([]);
	const [bulkChangeStatus, setBulkChangeStatus] = useState({ modal: false });
	const [bulkDeleteInvoices, setBulkDeleteInvoices] = useState({ modal: false });
    const [generateMgmtFee, setGenerateMgmtFee] = useState({ modal: false });
	const lessorAccess = JSON.parse(getGlobalCookie('lessorAccess') || 'null');
	const [bulkSendMail, setBulkSendMail] = useState({ modal: false });
	const [isQbEnabled, setIsQbEnabled] = useState(false);
	const [revertStatusInv, setRevertStatusInv] = useState({ modal: false, data: null });
	const [activeTab, setActiveTab] = useState(location.state?.activeTab ?? 0);
	const hasSummaryInvoicesReadAccess = permission?.permissions?.lease_revamp_application?.lease_revamp?.summary_invoice?.includes('R');
    
	useEffect(() => {
		if (!hasSummaryInvoicesReadAccess && activeTab === 1) {
			setActiveTab(0);
		}
	}, [hasSummaryInvoicesReadAccess]);

	const firstSelectedStatus = selectedInvoices.length > 0 ? selectedInvoices[0].status?.value : null;

	const canBulkSend = selectedInvoices.length > 0 && selectedInvoices.every(inv => inv?.status?.value === 2);

	const canBulkDelete = selectedInvoices.length > 0 && selectedInvoices.every(inv => inv?.status?.value === 1);

	// Multi Approval Flow (Titan) has no single approval_decision - "approved" only once every control stage is approved (item.approval_status), unlike the single-decision approval_decision.status used for the older flow.
	const isInvoiceApprovalPending = (item) => {
		const isMultiApprovalInvoice = titanAviationIntance && item?.is_invoice_approval && item?.invoice_type?.value !== 10 && (item?.invoice_type?.value === 1 || item?.parent_id);
		return isMultiApprovalInvoice ? item?.approval_status !== 'approved' : item?.approval_decision?.status !== 2;
	};

	const isQbSyncEligibleInvoice = (inv) => inv?.invoice_type?.value !== 10 && ([1, 2].includes(inv?.invoice_type?.value) || (hanwahaInstance && ([1, 2].includes(inv?.child_invoice_type) || [1, 2].includes(inv?.linked_invoice_type) || [4, 5, 6, 9].includes(inv?.invoice_type?.value))));
	const isBulkQbSyncable = (inv) => inv?.id != null && isQbSyncEligibleInvoice(inv) && !inv?.is_summary_linked && (hanwahaInstance ? inv?.status?.value !== 1 && inv?.qb_sync_required === true : inv?.status?.value === 2 && !inv?.qb_last_sync_by);

	const canSelectForStatusChange = (item) => {
		if (!hanwahaInstance && item?.qb_last_sync_by) return false;
		if (item?.is_summary_linked === true) return false;
		if (item?.is_invoice_approval && item?.invoice_type?.value !== 10 && !!item?.lease_slug && isInvoiceApprovalPending(item) && item?.status?.value === 1) return false;
		if (item?.status?.value === 2 && item?.bulk_selectable === false) return false;
		if (![1, 2].includes(item?.status?.value)) return false;
		if (item?.status?.value === 1 && item?.date && moment(item.date).isAfter(moment(), 'day')) return false;
		if (firstSelectedStatus !== null && item.status.value !== firstSelectedStatus) return false;
		if (getManagementFeeSelectDisabledReason(item, selectedInvoices)) return false;
		return true;
	};

	// The first selected invoice's status locks the selection - only invoices of that same status can be added.
	const isSameAsFirstSelectedStatus = (item) => firstSelectedStatus === null || item?.status?.value === firstSelectedStatus;
	const canSelectInvoice = (item) => canSelectForStatusChange(item) || (hanwahaInstance && isQbEnabled && isBulkQbSyncable(item) && isSameAsFirstSelectedStatus(item));

	const canBulkChangeStatus = selectedInvoices.length > 0 && (!hanwahaInstance || (selectedInvoices.every(canSelectForStatusChange) && !(selectedInvoices.some(inv => inv?.invoice_type?.value === 10) && selectedInvoices.some(inv => inv?.invoice_type?.value !== 10))));

	const getSelectDisabledReason = (item) => {
		if (canSelectInvoice(item)) return '';
		if (hanwahaInstance && !isSameAsFirstSelectedStatus(item) && !selectedInvoices.some(inv => inv.slug === item.slug))
			return `Only ${selectedInvoices[0]?.status?.label || 'same status'} invoices can be selected together. Deselect the current selection to choose a different status.`;
		if (!hanwahaInstance && item?.qb_last_sync_by && item?.is_summary_linked === true)
			return 'This invoice is linked with a Summary Invoice and is synced to QuickBooks, so this cannot be selected.';
		if (!hanwahaInstance && item?.qb_last_sync_by)
			return 'This invoice is synced to QuickBooks and cannot be selected.';
		if (item?.is_summary_linked === true)
			return 'This invoice is linked with a Summary Invoice and cannot be selected.';
		if (item?.is_invoice_approval && item?.invoice_type?.value !== 10 && !!item?.lease_slug && isInvoiceApprovalPending(item) && item?.status?.value === 1)
			return 'This invoice is not approved yet. Bulk status change is not available.';
		if (item?.status?.value === 1 && item?.date && moment(item.date).isAfter(moment(), 'day'))
			return `Invoice Date (${moment(item.date).format(fieldDateFormat)}) is in the future. Bulk status change is not available for this invoice.`;
		// Hanwha: invoices outside Draft/Sent are selectable only for QB sync - explain why when they aren't.
		if (hanwahaInstance && ![1, 2].includes(item?.status?.value)) {
			if (!isQbEnabled) return 'Only Draft and Sent invoices can be selected.';
			if (!isQbSyncEligibleInvoice(item)) return 'This invoice type cannot be synced to QuickBooks.';
			if (item?.qb_sync_required !== true) return 'This invoice is already synced to QuickBooks for its current status / payment.';
		}
		return getManagementFeeSelectDisabledReason(item, selectedInvoices);
	};

	const selectableInCurrentPage = invoicesInfo?.list?.filter(canSelectInvoice) || [];
	const selectedInCurrentPage = selectableInCurrentPage.filter(inv => selectedInvoices.some(s => s.slug === inv.slug));

	const onToggleSelectInvoice = (item) => {
		setSelectedInvoices(prev => {
			const alreadySelected = prev.some(inv => inv.slug === item.slug);
			return alreadySelected ? prev.filter(inv => inv.slug !== item.slug) : [...prev, item];
		});
	};

	const onSelectAll = () => {
		if (selectedInCurrentPage.length === selectableInCurrentPage.length) {
			setSelectedInvoices(prev => prev.filter(inv => !selectableInCurrentPage.some(s => s.slug === inv.slug)));
		} else {
			const toAdd = selectableInCurrentPage.filter(inv => !selectedInvoices.some(s => s.slug === inv.slug));
			setSelectedInvoices(prev => [...prev, ...toAdd]);
		}
	};


	useEffect(() => {
		setDrawerAssetType(undefined);
		setDrawerAircraftType(undefined);
		setDrawerEngineType(undefined);
	}, [filter.asset_type, filter.aircraft_type, filter.engine_type]);

	const fleetInvoiceFilterMenu = useMemo(() => {
		const activeAssetType = drawerAssetType === undefined ? filter.asset_type : drawerAssetType;
		const activeAircraftType = drawerAircraftType === undefined ? filter.aircraft_type : drawerAircraftType;
		const activeEngineType = drawerEngineType === undefined ? filter.engine_type : drawerEngineType;
		let filteredAssetList = assetList || [];
		if (activeAssetType) {
			filteredAssetList = filteredAssetList.filter(item => item.asset_type === activeAssetType);
			if (activeAssetType === 1 && activeAircraftType) {
				filteredAssetList = filteredAssetList.filter(item => item.aircraft_type_id === activeAircraftType);
			}
			if (activeAssetType === 2 && activeEngineType) {
				filteredAssetList = filteredAssetList.filter(item => item.engine_type_id === activeEngineType);
			}
		}
		return {
		asset_type: { title: 'Asset Type', inputType: 'dropdown', options: ASSET_TYPE_OPTIONS, valueKey: 'value', labelKey: 'label', multiple: false, dependentFields: ['aircraft_type', 'engine_type', 'asset_id'] },
		...(activeAssetType === 1 ? { aircraft_type: { title: 'Aircraft Type', inputType: 'dropdown', options: aircraftTypes || [], valueKey: 'id', labelKey: 'name', multiple: false, dependentFields: ['asset_id'] } } : {}),
		...(activeAssetType === 2 ? { engine_type: { title: 'Engine Type', inputType: 'dropdown', options: engineTypes || [], valueKey: 'id', labelKey: 'name', multiple: false, dependentFields: ['asset_id'] } } : {}),
		asset_id: { title: 'Asset', inputType: 'dropdown', options: filteredAssetList, valueKey: 'unique_key', labelKey: 'name', multiple: true, loading: assetListLoading, renderOption: (props, option) => ( <Box component="li" {...props} key={option.slug || option.unique_key}> {option.name} </Box>)  },
		invoice_number: { title: 'Invoice Number', inputType: 'text' },
		invoice_type: { title: 'Invoice Type', inputType: 'dropdown', options: invoiceTypeOptions, valueKey: 'value', labelKey: 'label', multiple: true },
		sub_type: { title: 'Sub-Type', inputType: 'dropdown', options: invoiceSubTypeOptions, valueKey: 'value', labelKey: 'label', multiple: true },
		status: { title: 'Status', inputType: 'dropdown', options: invoiceStatusOptions, valueKey: 'value', labelKey: 'label', multiple: true },
		invoice_start_date: { title: 'Invoice Date (Start Range)', inputType: 'date' },
		invoice_end_date: { title: 'Invoice Date (End Range)', inputType: 'date' },
		due_start_date: { title: 'Due Date (Start Range)', inputType: 'date' },
		due_end_date: { title: 'Due Date (End Range)', inputType: 'date' },
		lessor_id: { title: 'Lessor/Holdco', inputType: 'dropdown', options: owner || [], valueKey: 'id', labelKey: 'name', multiple: true },
		lessee_id: { title: 'Lessee', inputType: 'dropdown', options: lessee || [], valueKey: 'id', labelKey: 'name', multiple: true },
		overdue_days: { title: "Overdue Days", inputType: "number"},
		start_date: { title: 'Period Start Date', inputType: 'date' },
        end_date: { title: 'Period End Date', inputType: 'date' },
		payment_start_date: {title: 'Payment Start Date', inputType: 'date'},
		payment_end_date: {title: 'Payment End Date', inputType: 'date'},
		currency: { title: 'Currency', inputType: 'dropdown', options: currencies || [], valueKey: 'code', labelKey: 'name', multiple: true, },
		...(titanAviationIntance ? {
			mr_approval_status_finance: {
				inputType: 'dropdown',
				placeholder: 'Select MR Approval Status (Finance)',
				options: [{ label: 'Approved', value: 2 }],
				title: 'MR Approval Status (Finance)',
				labelKey: 'label',
				valueKey: 'value',
				dependentFields: ['mr_pending_approval_by'],
				disabledWhen: (filterOption) => !!filterOption?.mr_pending_approval_by,
			},
			mr_approval_status_accounting: {
				inputType: 'dropdown',
				placeholder: 'Select MR Approval Status (Accounting)',
				options: [{ label: 'Approved', value: 2 }, { label: 'Rejected', value: 3 }],
				title: 'MR Approval Status (Accounting)',
				labelKey: 'label',
				valueKey: 'value',
				dependentFields: ['mr_pending_approval_by'],
				disabledWhen: (filterOption) => !!filterOption?.mr_pending_approval_by,
			},
			mr_approval_status_final: {
				inputType: 'dropdown',
				placeholder: 'Select MR Approval Status (Final)',
				options: [{ label: 'Approved', value: 2 }, { label: 'Rejected', value: 3 }],
				title: 'MR Approval Status (Final)',
				labelKey: 'label',
				valueKey: 'value',
				dependentFields: ['mr_pending_approval_by'],
				disabledWhen: (filterOption) => !!filterOption?.mr_pending_approval_by,
			},
			mr_pending_approval_by: {
				title: 'MR Invoice Pending Approval By',
				inputType: 'dropdown',
				options: mrPendingApprovalStageOptions || [],
				valueKey: 'value',
				labelKey: 'label',
				dependentFields: ['mr_approval_status_finance', 'mr_approval_status_accounting', 'mr_approval_status_final'],
				disabledWhen: (filterOption) => !!(filterOption?.mr_approval_status_finance || filterOption?.mr_approval_status_accounting || filterOption?.mr_approval_status_final),
			},
		} : {}),
		onDependencyChange: (keyParam, value) => {
			if (keyParam === 'asset_type') setDrawerAssetType(value != null ? value : null);
			if (keyParam === 'aircraft_type') setDrawerAircraftType(value != null ? value : null);
			if (keyParam === 'engine_type') setDrawerEngineType(value != null ? value : null);
		},
		onOpen: () => { setDrawerAssetType(undefined); setDrawerAircraftType(undefined); setDrawerEngineType(undefined); },
		};
	}, [assetList, assetListLoading, owner, lessee, currencies, aircraftTypes, engineTypes, filter.asset_type, filter.aircraft_type, filter.engine_type, drawerAssetType, drawerAircraftType, drawerEngineType]);

	useEffect(() => {
		getInvoices('skeletonLoader', { per_page: 50, sort_by: sortInfo.sort_by, sort: sortInfo.sort });
		getAssetList();
		dispatch(getOwnerListApi({}));
		dispatch(getLesseeAc({}));
		dispatch(getCurrencyAc({}));
		trackActivity('Page Viewed',{ page_title: 'Fleet Invoices'});
		globalGetService(getAircraftTypeList()).then(response => {
			if (checkApiStatus(response)) setAircraftTypes(response?.data?.data || []);
		});
		globalGetService(getEngineTypeList()).then(response => {
			if (checkApiStatus(response)) setEngineTypes(response?.data?.data?.engineTypes || []);
		});
		globalGetService(getQbStatusApi()).then(response => {
			if (checkApiStatus(response)) setIsQbEnabled(response.data.data?.is_lessor_enabled || false);
		});
	}, [dispatch]);
	const getInvoices = (loaderType, query = {}) => {
		const queryParams = { ...query };
		if (queryParams.asset_id) {
			queryParams.asset_id = queryParams.asset_id.toString().split(',').map(key => { const [id, type] = key.split('_'); return `(${id},${type})`; });
		}
		loaderType === 'skeletonLoader' ? setSkeletonLoader(true) : setLoading(true);
		globalGetService(getInvoicesApi(params, queryParams), {}).then(response => {
			loaderType === 'skeletonLoader' ? setSkeletonLoader(false) : setLoading(false);
			if (checkApiStatus(response)) {
				setInvoicesInfo(response?.data?.data)
			}
		});
		dispatch(getStorage({module_name:"invoices"}));
	}

	const createSortHandler = (key) => {
		let sortQuery = { sort_by: key }
		if (sortInfo.sort_by === key) {
			sortQuery = { ...sortQuery, sort: sortInfo.sort === 'asc' ? 'desc' : 'asc' }
		} else {
			sortQuery = { ...sortQuery, sort: 'asc' }
		}
		setSortInfo(sortQuery)
		setSelectedInvoices([]);
		getInvoices('', {
			...filter,
			...sortQuery,
			page: invoicesInfo?.pagination?.current_page || 1,
			per_page: invoicesInfo?.pagination?.per_page || 50,
		});
	}

	const onApplyFilter = (query) => {
		if (query.start_date && query.end_date && moment(query.start_date).isAfter(moment(query.end_date), 'day')) {
			enqueueSnackbar('Period Start Date must be before End Date', { variant: 'error' });
			return false;
		}
		if (query.invoice_start_date && query.invoice_end_date && moment(query.invoice_start_date).isAfter(moment(query.invoice_end_date), 'day')) {
			enqueueSnackbar('Invoice Date Start Range must be before End Range', { variant: 'error' });
			return false;
		}
		if (query.due_start_date && query.due_end_date && moment(query.due_start_date).isAfter(moment(query.due_end_date), 'day')) {
			enqueueSnackbar('Due Date Start Range must be before End Range', { variant: 'error' });
			return false;
		}
		if (query.invoice_start_date && query.due_start_date && moment(query.due_start_date).isBefore(moment(query.invoice_start_date), 'day')) {
			enqueueSnackbar('Due Date Start Range cannot be before Invoice Date Start Range', { variant: 'error' });
			return false;
		}
		if (query.invoice_start_date && query.due_end_date && moment(query.due_end_date).isBefore(moment(query.invoice_start_date), 'day')) {
			enqueueSnackbar('Due Date End Range cannot be before Invoice Date Start Range', { variant: 'error' });
			return false;
		}
		if (query.payment_start_date && query.payment_end_date && moment(query.payment_start_date).isAfter(moment(query.payment_end_date), 'day')) {
			enqueueSnackbar('Payment Start Date must be before Payment End Date', { variant: 'error' });
			return false;
		}
		setFilter(query);
		setSelectedInvoices([]);
		getInvoices('', { ...query, page: 1, per_page: invoicesInfo?.pagination?.per_page || 50 });
	}

	const onDeleteInvoice = () => {
		setLoading(true);
		globalDeleteService(deleteInvoiceApi(params), getDeleteInvoicePayload(deleteInvoices?.data))
			.then(response => {
				if (checkApiStatus(response)) {
					trackActivity('Item Deleted', { page_title: `Delete Fleet Invoice`, success_msg: response?.data?.message, item_ids: deleteInvoices?.data, qb_synced: !!deleteInvoices?.data?.qb_last_sync_by, response: response?.data })
					setDeleteInvoices({ modal: false, data: null });
					getInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 });
					headerCardRef.current?.refresh();
					setSelectedInvoices([]);
					enqueueSnackbar(response?.data?.message, { variant: "success", anchorOrigin: { horizontal: "right", vertical: "top" }, });
				} else {
					setLoading(false);
					enqueueSnackbar(response?.data?.message, { variant: "error", anchorOrigin: { horizontal: "right", vertical: "top" }, });
					trackActivity('Item Deleted', { page_title: `Delete Fleet Invoice`, error_msg: response?.data?.message, item_ids: deleteInvoices?.data, response: response?.data })
				}
			})
	}

	const onDeteAttchments = (deltedslug) => {
		if (addEditInvoice?.modal) {
			setAddEditInvoice({
				...addEditInvoice,
				data: {
					...addEditInvoice.data,
					attachments: addEditInvoice.data.attachments.filter(item => item?.slug !== deltedslug)
				}
			})
		}
		getInvoices('', { page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 });
	}

	const getAssetList = () => {
		setAssetListLoading(true);
		globalGetService(getAssetListApi({ is_invoice: true })).then(response => {
			setAssetListLoading(false);
			if (checkApiStatus(response)) {
				const formatted = (response?.data?.data || []).map(item => ({
					...item,
					unique_key: `${item.id}_${item.asset_type}`,
				}));
				setAssetList(formatted);
			}
		});
	};

	const handleSummaryReport = () => {
		setLoading(true);
		globalGetService(getInvoiceApprovalReportApi({ file_type: 'xlsx' })).then((response) => {
			setLoading(false);
			if (checkApiStatus(response)) {
				enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
			} else {
				enqueueSnackbar(response?.data?.message, { variant: 'error', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
			}
		});
	}
	const handleExport = (fileType) => {
		let query = { ...filter, export: true, file_type: fileType }
		if (sortInfo?.sort && sortInfo?.sort_by) {
			query = {
				...query,
				sort: sortInfo?.sort,
				sort_by: sortInfo?.sort_by
			}
		}
		if (query.asset_id) {
			query.asset_id = query.asset_id.toString().split(',').map(key => { const [id, type] = key.split('_'); return `(${id},${type})`; });
		}
		fileType === 'bulk_download_pdf' ? setIsBulkExport(true) : seIsExport(true);
		globalGetService(getInvoicesApi(params, query)).then((response) => {
			if (checkApiStatus(response)) {
				enqueueSnackbar( response?.data.message, { variant: "success", anchorOrigin: { vertical: "top", horizontal: "right" } } );
				fileType === 'bulk_download_pdf' ? setIsBulkExport(false) : seIsExport(false);
			}
			else {
				enqueueSnackbar( response?.data.message, { variant: "error", anchorOrigin: { vertical: "top", horizontal: "right" } } );
				fileType === 'bulk_download_pdf' ? setIsBulkExport(false) : seIsExport(false);
			}
		})
	}
	const handleUpload = async (slug) => {
		setSlug({ slug: slug })
		await fileUpload({
			attachments: fileUploadDetails.attachments,
			module_name: "invoices",
			slug: slug,
			onStart: () => setLoading(true),
			onComplete: () => setLoading(false),
			onProgress: ({ progressRefs, attachments, response }) => {
				setUploadFileProgressData({ progressRefs, attachments, response });
			},
			onSuccess: (success_msg) => {
				enqueueSnackbar(success_msg, {
					variant: "success",
					anchorOrigin: { vertical: "top", horizontal: "right" }
				});
			},
			onError: (err) => {
				enqueueSnackbar(`${err?.message}` || "Error while uploading files", {
					variant: "error",
					anchorOrigin: { vertical: "top", horizontal: "right" }
				});
			}
		});
		setSlug({})
	};  
	const sentInvoicesForSync = selectedInvoices.filter(isBulkQbSyncable).slice(0, 50);

	const syncInvoicesToQb = () => {
		const invoiceIds = sentInvoicesForSync.map(inv => inv.id).join(',');
		setLoading(true);
		globalGetService(getInvoiceAuthUrl({ invoice_id: invoiceIds })).then(response => {
			setLoading(false);
			if (checkApiStatus(response)) {
				setGlobalCookie('thirdPartyInvoiceState', 'SyncInvoiceFromQB');
				window.open(response.data.data.url, '_blank');
			}
		});
	};

	const syncFromQb = () => {
		setLoading(true);
		globalGetService(getInvoiceAuthUrl()).then(response => {
			setLoading(false);
			if (checkApiStatus(response)) {
				setGlobalCookie('thirdPartyInvoicePullState', 'SyncInvoicePullFromQB');
				window.open(response.data.data.url, '_blank');
			}
		});
	};

	const handleItemClicked = (page_type) => {
		trackActivity('Item Clicked', { page_title: `Fleet Invoices`, page_type: page_type, })
	}

	const handleTabChange = (e, newValue) => {
		setActiveTab(newValue);
		setSelectedInvoices([]);
		handleItemClicked(`Tab Selected: ${newValue === 1 ? 'Summary Invoices' : 'Fleet Invoices'}`);
	}
	return (
		<section className="active-asset-section">
			<DeploymentBannerWithOffset>
				{(bannerHeight) => (
			<Paper className="lease-module-paper" elevation={0} sx={{ overflow: 'hidden' }}>
				<Paper elevation={2} square sx={{ padding: '5px' }} className="active-asset-header">
					<Grid mb={1}>
						<FleetInvHeaderCard ref={headerCardRef} />
					</Grid>
					<Paper elevation={0} className="lease-module-paper" style={{ margin: '7px 1px 5px 1px' }}>
						<Tabs
							className="reserve-rate-invoice-tab"
							value={activeTab}
							onChange={handleTabChange}
							sx={{ borderColor: 'divider', minHeight: 42, '& .MuiTab-root': { minHeight: 42, height: 42 } }}
						>
							<Tab className="ile-name" label="Fleet Invoices" value={0} />
							{hasSummaryInvoicesReadAccess && <Tab className="ile-name" label="Summary Invoices" value={1} />}
						</Tabs>
					</Paper>
					{activeTab === 0 && (
						<Grid container spacing={1} sx={{ justifyContent: 'space-between', alignItems: 'center', placeItems:'flex-start' }}>
							<Grid size='grow' sx={{ minWidth: 0 }}>
								<Box display="flex" alignItems="center" gap={1} flexShrink={0} sx={{ marginTop: '2px' }}>
									{!skeletonLoader ? <FilterComponent filter={filter} filterMenu={fleetInvoiceFilterMenu} getResponseBack={onApplyFilter} /> : null}
								</Box>
							</Grid>
							<Grid md={8} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
								<ul className="list-inline">
									<li className='lease-mobile-button revision-history' style={{ marginRight: '5px' }}>
										<ModuleWiseRevisionHistory ViewGlobalHistory={() => { setRevisionHistory({ modal: true, mode: '', data: { type: "global" } }); handleItemClicked('Global Revision HistoryIcon') }} />
									</li>
									{isQbEnabled && invoicesInfo?.list?.length > 0 && (
										<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
											{jetStreamInstance ?
											<li className='lease-mobile-button' style={{ marginRight: '5px' }}>
												<Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { syncFromQb(); handleItemClicked('Sync from QB Button') }}>Sync from QB</Button>
											</li> : null}
											<li className='lease-mobile-button' style={{ marginRight: '5px' }}>
												<Button variant="contained" color="primary" size='small' className='btn-primary' disabled={sentInvoicesForSync.length === 0} onClick={() => { syncInvoicesToQb(); handleItemClicked('Sync to QB Button') }}>Sync to QB ({sentInvoicesForSync.length})</Button>
											</li>
										</PermissionWrapper>
									)}
									{jetStreamInstance &&
										<li className='lease-mobile-button' style={{ marginRight: '5px' }}>
											<Button variant="contained" color="primary" size='small' className='btn-primary' onClick={() => { handleSummaryReport(); handleItemClicked('Approval Report Button') }}>Approval Report</Button>
										</li>
									}
									{invoicesInfo?.list?.length > 0 ? <li className='lease-mobile-button' style={{ marginRight: '5px' }}><ExportFileTypeComp handelExport={handleExport} isLoading={isExport} /> </li> : null}
									{invoicesInfo?.list?.length > 0 ? <li className='lease-mobile-button' style={{ marginRight: '5px' }}><Button disabled={isBulkExport} onClick={() => { handleExport('bulk_download_pdf'); handleItemClicked('Bulk Export Button') }} variant="contained" size="small" color="primary">Bulk Export</Button></li> : null}
									{canBulkChangeStatus &&
										<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: [']'] }}>
											<li className='lease-mobile-button' style={{ marginRight: '5px' }}>
												<Button
													variant="contained"
													size="small"
													color="secondary"
													onClick={() => { setBulkChangeStatus({ modal: true }); handleItemClicked('Bulk Change Status') }}
												>
													Bulk Change Status ({selectedInvoices.length})
												</Button>
											</li>
										</PermissionWrapper>
									}
									{canBulkDelete &&
										<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['D'] }}>
											<li className='lease-mobile-button' style={{ marginRight: '5px' }}>
												<Button
													variant="contained"
													size="small"
													color="error"
													onClick={() => { setBulkDeleteInvoices({ modal: true }); handleItemClicked('Bulk Delete Invoice') }}
												>
													Bulk Delete ({selectedInvoices.length})
												</Button>
											</li>
										</PermissionWrapper>
									}
								{canBulkSend &&
									<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
										<li className='lease-mobile-button' style={{ marginRight: '5px' }}>
											<Button
												variant="contained"
												size="small"
												color="primary"
												onClick={() => { setBulkSendMail({ modal: true }); handleItemClicked('Bulk Invoice Send') }}
											>
												Bulk Send Invoice ({selectedInvoices.length})
											</Button>
										</li>
									</PermissionWrapper>
								}
								<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
									{invoicesInfo?.list?.length > 0 ? <li className='lease-mobile-button' style={{ marginRight: '5px' }}>
										<Button variant="contained" size="small" color="primary" onClick={() => { setGenerateMgmtFee({ modal: true }); handleItemClicked('Generate Management Fee') }}>
											Generate Management Fee
										</Button>
									</li> : null }
								</PermissionWrapper>
									<PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['C'] }}>
										<li className="list-inline-item">
											<PopOverCTA btnText={`Add Invoice`} btnDisabled={skeletonLoader} varientText={'contained'} onCloseItem={true} >
												<>
													<MenuItem onClick={() => { setAddEditInvoice({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Ad Hoc Invoice', value: 9 } }, mode: 'add', type: 'adhoc' }); handleItemClicked('Add Adhoc Invoice') }}>Adhoc Invoice</MenuItem>
													<MenuItem onClick={() => { setAddEditInvoice({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Credit Note Invoice', value: 5 } }, mode: 'add', type: 'credit' }); handleItemClicked('Add Credit Invoice') }}>Credit Note</MenuItem>
													<MenuItem onClick={() => { setAddEditInvoice({ modal: true, data: { ...addInvoiceObj, invoice_type: { label: 'Debit Note Invoice', value: 4 } }, mode: 'add', type: 'debit' }); handleItemClicked('Add Debit Invoice') }}>Debit Note</MenuItem>
												</>
											</PopOverCTA>
										</li>
									</PermissionWrapper>
								</ul>
							</Grid>
						</Grid>
					)}
				</Paper>
				{activeTab === 0 && (
					<Paper className="active-asset-list" square>
						{skeletonLoader ? <STableLoader count={6} rowCount={9} /> :
							<div className="fleet-inv-content" style={{ maxHeight: `${window.innerHeight - 363 - bannerHeight}px`, overflow: "auto", boxSizing: 'border-box' }}>
								<Table className="mui-table-format" stickyHeader>
									<InvoicesHd
										sortInfo={sortInfo}
										createSortHandler={createSortHandler}
										bulkFlag={invoicesInfo?.list?.length > 0 ? invoicesInfo?.list?.length === deleteInvoices?.data?.ids?.length : false}
										selectedCount={selectedInCurrentPage.length}
										selectableCount={selectableInCurrentPage.length}
										onSelectAll={onSelectAll}
										hasAnySelection={selectedInvoices.length > 0}
									/>
									<TableBody>
										{invoicesInfo?.list?.length > 0 && invoicesInfo?.list?.map((item, index) => {
											const uploadedFileData = getApiResponse("invoices", item?.slug);
											return (
												<InvoiceList
													slug={slug?.slug}
													uploadedFileData={uploadedFileData}
													uploadFileProgressData={uploadFileProgressData}
													viewFileStatus={(uploadedFileData) => setUploadFileStatus({ modal: true, data: uploadedFileData, mode: 'view' })}
													key={index}
													item={item}
													onDelete={(e) => setDeleteInvoices({ modal: true, data: item })}
													viewFile={() => setUploadAttachments({ modal: true, data: item })}
													onView={() => {
                                                        sessionStorage.setItem("invoiceViewFrom", "viewFromFleet");
                                                        window.open(`/invoices/view/${item?.slug}`, "_blank");
                                                    }}
													viewFrom={() => sessionStorage.setItem("invoiceViewFrom", "viewFromFleet")}
													onInvStatus={() => setChangeInvStatus({ modal: true, data: item })}
													viewRevisonHistory={() => setRevisionHistory({ modal: true, data: item, mode: 'view' })}
													onRevertStatus={() => setRevertStatusInv({ modal: true, data: item })}
													canSelect={canSelectInvoice(item)}
													selectDisabledReason={getSelectDisabledReason(item)}
													isSelected={selectedInvoices.some(s => s.slug === item.slug)}
													onToggleSelect={() => onToggleSelectInvoice(item)}
												/>
										)})}
									</TableBody>
								</Table>
							</div>
						}
						{!skeletonLoader && invoicesInfo?.list?.length === 0 ? <NoRecordFound /> : null}
						<Paper>
						<Pagination
							pagination={invoicesInfo?.pagination}
							onPageChange={(event, newPage) => { setSelectedInvoices([]); getInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: newPage + 1, per_page: invoicesInfo?.pagination?.per_page }); }}
							onRowsPerPageChange={(e) => { setSelectedInvoices([]); getInvoices('', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: 1, per_page: e.target.value }); }}
						/>
						</Paper>
					</Paper>
				)}
				{activeTab === 1 && hasSummaryInvoicesReadAccess && <SummaryInvoices />}
			</Paper>
			)}
			</DeploymentBannerWithOffset>
			{isLoading ? <PageLoader /> : null}
			{changeInvStatus.modal ?
				<ChangeInvoiceStatus
					invoiceStatus={changeInvStatus}
                    invoiceType={changeInvStatus?.data?.invoice_type?.label}
					offsetInvoice={changeInvStatus?.data?.offset_invoice}
					onToggleModal={() => setChangeInvStatus({ modal: false, data: {} })}
					getResponseBack={() => { setSelectedInvoices([]); getInvoices('pageLoader', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50}); headerCardRef.current?.refresh(); }}
				/> : null
			}
			{bulkChangeStatus.modal ?
				<BulkChangeInvoiceStatus
					selectedInvoices={selectedInvoices}
					onClose={() => setBulkChangeStatus({ modal: false })}
					getResponseBack={() => {
						setSelectedInvoices([]);
						getInvoices('pageLoader', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50}); headerCardRef.current?.refresh();
					}}
				/> : null
			}
			{bulkDeleteInvoices.modal ?
				<BulkDeleteInvoiceModal
					selectedInvoices={selectedInvoices}
					params={params}
					pageTitle="Fleet Invoices"
					onClose={() => setBulkDeleteInvoices({ modal: false })}
					getResponseBack={() => {
						setSelectedInvoices([]);
						getInvoices('pageLoader', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50}); headerCardRef.current?.refresh();
					}}
				/> : null
			}
			{bulkSendMail.modal ?
				<BulkSendMailModal
					selectedInvoices={selectedInvoices}
					onClose={() => setBulkSendMail({ modal: false })}
					onSuccess={() => setSelectedInvoices([])}
					getResponseBack={() => {
						setSelectedInvoices([]);
					    getInvoices('pageLoader', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50}); headerCardRef.current?.refresh();
					}}
				/> : null
			}
			{addEditInvoice.modal ?
				<AddFleetInvoice
					addEditInvoice={addEditInvoice}
					getResponseBack={() => getInvoices('pageLoader', { page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 })}
					onToggleModal={() => setAddEditInvoice({ modal: false, mode: '', data: null })}
					fileUpload={handleUpload}
				/> : null}

			{deleteInvoices.modal ?
				<DeletePopUp
					modal={deleteInvoices.modal}
					title={'Delete Invoice'}
					onDeleteRecords={() => onDeleteInvoice()}
					{...getDeleteInvoicePopUpProps(deleteInvoices?.data)}
						onToggleModal={() => setDeleteInvoices({ modal: false, data: null })}
					/> : null}

			{revertStatusInv.modal ?
				<RevertInvoiceStatus
					revertStatusInv={revertStatusInv}
					onToggleModal={() => setRevertStatusInv({ modal: false, data: null })}
					getResponseBack={() => {setSelectedInvoices([]); getInvoices('pageLoader', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50}); headerCardRef.current?.refresh(); }}
				/> : null}

			{uploadAttachments.modal ? <UploadAttachmentsModal
				uploadAttachments={uploadAttachments}
				onToggleModal={() => setUploadAttachments({ modal: false, data: null })}
				invSlug={(slug) => setSlug({ slug: slug })}
				onAttachmentDeleted={onDeteAttchments}
				progressData={(data) => setUploadFileProgressData(data)}
				getResponseBack={() => { getInvoices('pageLoader', {...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50}) }}
			/> : null}
			<FileUploadLayout
				uploadFileStatus={uploadFileStatus}
				open={uploadFileStatus?.modal}
				setUploadFileStatus={setUploadFileStatus}
				uploadFileProgressData={uploadFileProgressData}
				progressRefs={uploadFileProgressData?.progressRefs}
				attachments={uploadFileProgressData?.attachments}
				onDownloadComplete={()=> setSlug({})}
			/>
			{revisionHistory.modal &&
				<RevisionHistory moduleName={"invoices"} revisionHistory={revisionHistory} onToggleModal={() => setRevisionHistory({ modal: false, mode: '', data: null })} />
			}
			{generateMgmtFee.modal &&
				<GenerateManagementFeeModal
					onToggleModal={() => setGenerateMgmtFee({ modal: false })}
					getResponseBack={() => { getInvoices('pageLoader', { ...filter, ...(sortInfo.sort_by ? { sort: sortInfo.sort, sort_by: sortInfo.sort_by } : {}), page: invoicesInfo?.pagination?.current_page || 1, per_page: invoicesInfo?.pagination?.per_page || 50 }) }}
				/>
			}
		</section>
	);
};
export default RoleBaseAccess(FleetInvoices, { application: 'lease_revamp', feature: 'invoices', operationType: ['R'] });
